


































































































































































































































































interface DelIds {
    check: boolean;
    customer: string;
    id: string | number;
    invoiceNo: string;
    url: string | null;
}
import { Component, Watch, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";

import ThDropdownVue from "../components/ThDropdown.vue";
import MonthSelectorVue from "../components/MonthSelector.vue";
import ChangePeriodVue from "../components/Invoice/ChangePeriod.vue";
import InvoiceAddVue from "../components/Invoice/InvoiceAdd.vue";
import InvoiceImportVue from "../components/Invoice/InvoiceImport.vue";
import ImportZipVue from "../components/Invoice/ImportZip.vue";
import { Providers, ProviderArr } from "@/data/BusinessTypes";
import DepartList, { DepartArray } from "@/data/DepartList";
import InvoiceScanVue from "@/components/Invoice/InvoiceScan.vue";
import version from "@/version";

@Component({
    ...mapGetters(["accountBook"]),
    components: {
        "th-dropdown": ThDropdownVue,
        "month-selector": MonthSelectorVue,
        "change-period": ChangePeriodVue,
        "invoice-add": InvoiceAddVue,
        "invoice-import": InvoiceImportVue,
        "import-zip": ImportZipVue,
        "invoice-scan": InvoiceScanVue
    },
})
export default class VATInvoice extends Vue {
    closePeriod: boolean = true; //是否结账
    showCheck: boolean = false; //是否销项
    allChecked: boolean = false; //是否全选
    clickPer: boolean = false;
    delIds: DelIds[] = [];
    searchKey: string = "";
    fnAllChecked(val: boolean) {
        this.delIds.forEach((v: DelIds) => {
            if (this.batch === 5) {
                if (v.url !== null && v.url !== "") v.check = val;
                else v.check = false
            } else v.check = val
        });
    }
    filterVisible: boolean = false
    confirmFilter() {
        this.fetchData()
        this.filterVisible = false
    }
    resetFilter() {
        this.startDate = ""
        this.endDate = ""
        this.minPriceTaxAmount = ""
        this.maxPriceTaxAmount = ""
    }
    startDate = ""
    endDate = ""
    minPriceTaxAmount = ""
    maxPriceTaxAmount = ""
    // 分页
    pageSize: number = 20;
    currentPage: number = 1;
    totalElements: number = 0;
    // 修改页数SIze
    changeSize(size: number) {
        this.pageSize = size;
        this.fetchData();
    }
    // 改变分页
    changePage(page: number) {
        this.currentPage = page;
        this.fetchData();
    }
    // 点击行
    enterDetail(el: any, val: any) {
        if (
            el.target.classList[0] === "el-checkbox__inner" ||
            el.target.classList[0] === "el-checkbox__original" ||
            el.target.classList[0] === "el-checkbox"
        ) {
            return;
        }
        this.addInvoiceData = val;
        if (val.isProviderOrCustomer === "1") {
            this.invoiceAddTitle = "进项发票";
        } else {
            this.invoiceAddTitle = "销项发票";
        }
        this.invoiceAdd = true;
    }
    // 导入销项/进项
    invoiceName: string = "";
    importChange: boolean = false;
    invoiceImport: boolean = false; //是否打开弹窗
    importData(isZip?: boolean) {
        if (this.purchase) this.invoiceName = "销项发票";
        else this.invoiceName = "进项发票";
        if (this.invoiceName === "销项发票") {
            this.importChange = true;
        } else {
            this.importChange = false;
        }
        if (!isZip) this.invoiceImport = true;
        else this.importZipVisbile = true;
    }
    successImport(val: boolean, mes: string, isZip?: boolean) {
        if (val) {
            this.purchase = this.importChange;
            this.changeIncoiceType(this.purchase ? 0 : 1);
            // this.fetchData();
            this.$alert(mes, "温馨提示");
        }
        if (!isZip) this.invoiceImport = false;
        else this.importZipVisbile = false;
    }
    closeImport(isZip?: boolean) {
        if (!isZip) this.invoiceImport = false;
        else {
            this.importZipVisbile = false;
            this.fetchData();
        }
    }
    // 新增销项/进项
    invoiceAddTitle: string = "";
    invoiceAdd: boolean = false;
    addInvoiceData: Invoice.AddInvoice | null = null;
    invoiceAddSuccess(val: boolean) {
        if (val) this.fetchData();
        else {
            this.invoiceAdd = false;
        }
    }
    addInvoice(command: string) {
        this.addInvoiceData = {
            id: null,
            accountBookId: this.$store.state.accountBook.id,
            invoiceNo: null,
            period: this.period[1].toString(),
            invoiceDate: null,
            invoiceType:
                this.$store.state.accountBook.addtax === "小规模纳税人"
                    ? "0"
                    : "1",
            createType: "0",
            remark: null,
            provider: null,
            customer: null,
            taxCode: null,
            bankNo: null,
            moneyAmounts: null,
            taxAmounts: null,
            department: null,
            status: 0,
            isProviderOrCustomer: 0,
            businessType: "7",
            invoiceDetails: [],
        };
        if (this.purchase) {
            this.invoiceAdd = true;
            this.addInvoiceData.isProviderOrCustomer = 0;
            this.invoiceAddTitle = "新增销项发票";
        } else {
            this.invoiceAdd = true;
            this.addInvoiceData.isProviderOrCustomer = 1;
            this.addInvoiceData.businessType = "0";
            this.invoiceAddTitle = "新增进项发票";
        }
    }
    // 批量
    batch: number = 0;
    notAllow: boolean = false;
    delButton: string = "批量删除";
    rzButton: string = "批量认证";
    perButton: string = "批量修改期间";
    showPerChange: boolean = false; //展示修改时间
    perChangeSuccess(val?: boolean) {
        if (val) {
            this.fetchData();
            this.batch = 0;
        }
        this.showPerChange = false;
    }
    // 批量切换
    batchList(command: string) {
        if (command === "批量删除") {
            this.batch = 1;
            this.showCheckBox(command);
        } else if (command === "批量认证") {
            this.batch = 3;
            this.rzButton = "批量认证"
            this.showRenz(command);
        } else if (command === "取消认证") {
            this.batch = 4;
            this.rzButton = "取消认证"
            this.showQx(command);
        } else if (command === "勾选认证") {
            this.$utils.oneKeyLogin(this.$store.state.accountBook.id, this);
        } else if (command === "打印发票影像") {
            this.batch = 5;
            this.downButton = "打印发票影像"
            this.downLoad(command);

        } else if (command === "销项") {
            this.export()
        } else if (command === "生成凭证") {
            this.downButton = "生成凭证";
        } else {
            this.batch = 2;
            this.showPerCheck(command);
        }
    }
    // 点击批量修改时间
    showPerCheck(command: string) {
        if (command === "批量修改期间") {
            this.showCheck = true;
            this.clickPer = true;
            this.perButton = "取消";
        } else if (this.perButton === "修改期间") {
            this.showPerChange = true;
        } else if (this.perButton === "取消") {
            this.showPerChange = false;
            this.showCheck = false;
            this.clickPer = false;
            this.perButton = "批量修改期间";
            this.batch = 0;
        }
    }
    //监听批量选择
    @Watch("delIds", { deep: true })
    delIdsChange(val: DelIds[]) {
        let all = true,
            hasSelect = false;
        val.forEach((v: DelIds) => {
            if (!v.check) all = false;
            else hasSelect = true;
        });
        this.allChecked = all;
        if (hasSelect) {
            if (this.notAllow) this.delButton = "批量删除";
            else if (this.clickPer) this.perButton = "修改期间";
            else if (this.isRz) this.rzButton = "批量认证"
            else if (this.isQx) this.rzButton = "取消认证"
            else if (this.isDown) this.downButton = "打印发票影像"
        } else if (this.delButton === "批量删除") {
            if (this.notAllow) this.delButton = "取消";
            else if (this.clickPer) this.perButton = "取消";
            else if (this.isRz) this.rzButton = "取消";
            else if (this.isQx) this.rzButton = "取消";
            else if (this.isDown) this.downButton = "取消";
        }
    }
    isDisabled(item: any) {
        if (this.batch === 5) {
            if (item.url !== null && item.url !== "") return false
            else return true
        }
        else return false
    }
    // 批量打印
    downButton: string = "打印发票影像"
    isDown: boolean = false
    downLoad(command: string) {
        if (this.downButton === "打印发票影像") {
            if (this.delIds.length === 0) {
                console.log(this.batch, 33)

                this.downButton = "取消";
            }
            if (this.isDown == true) {
                this.downImg(command);
            } else {
                this.downButton = "取消";
                this.showCheck = true;
                this.isDown = true;
            }
        } else {
            this.downButton = "打印发票影像";
            this.showCheck = false;
            this.isDown = false;
            this.batch = 0;
        }
    }
    downImg(command: string) {
        let delIdArray: any = [];
        this.delIds.forEach((val: DelIds) => {
            if (val.check) {
                delIdArray.push(val.id);
            }
        });
        this.$msgbox({
            message: `您共选了 ${delIdArray.length} 张发票，是否确认？`,
            title: "温馨提示",
            confirmButtonText: "确定",
            showCancelButton: true,
        }).then((action: any) => {
            if (action == "confirm") {
                this.$utils.sendToElectron("download-pdf", `${Vue.axios.defaults.baseURL}export/pdf/invoice/print?id=${delIdArray.join(",")}&version=${version}&token=${this.$store.state.account.token}`);
                // this.$utils.sendToElectron("download", `${Vue.axios.defaults.baseURL}export/pdf/invoice/print?id=${delIdArray.join(",")}&version=${version}&token=${this.$store.state.account.token}`)
                this.downButton = command;
                this.showCheck = false;
                this.isDown = false;
                this.fetchData();
                this.batch = 0;
            }
        });
    }
    // 批量认证
    isRz = false
    isQx = false
    showRenz(command: string) {
        console.log(this.rzButton)
        if (this.rzButton === "批量认证") {
            if (this.delIds.length === 0) {
                this.rzButton = "取消";
            }
            if (this.isRz == true) {
                this.rz(command);
            } else {
                this.rzButton = "取消";
                this.showCheck = true;
                this.isRz = true;
            }
        } else {
            this.rzButton = "批量认证";
            this.showCheck = false;
            this.isRz = false;
            this.batch = 0;
        }
    }
    showQx(command: string) {
        if (this.rzButton === "取消认证") {
            if (this.delIds.length === 0) {
                this.rzButton = "取消";
            }
            if (this.isQx == true) {
                this.rz(command);
            } else {
                this.rzButton = "取消";
                this.showCheck = true;
                this.isQx = true;
            }
        } else {
            this.rzButton = "取消认证";
            this.showCheck = false;
            this.isQx = false;
            this.batch = 0;
        }
    }
    // 认证
    rz(command: string) {
        let delIdArray: any = [];
        this.delIds.forEach((val: DelIds) => {
            if (val.check) {
                delIdArray.push(val.id);
            }
        });
        let text = ""
        let status = "1"
        if (command === "取消认证") {
            text = "取消认证"
            status = "0"
        } else {
            text = "认证"
            status = "1"
        }
        this.$msgbox({
            message: `您共选了 ${delIdArray.length} 张发票，是否确认${text}？`,
            title: "温馨提示",
            confirmButtonText: "确定",
            showCancelButton: true,
        }).then((action: any) => {
            if (action == "confirm") {
                Vue.axios
                    .post(`invoice/auth?id=${delIdArray.join(",")}&status=${status}`)
                    .then((res) => {
                        this.rzButton = command;
                        this.showCheck = false;
                        this.isRz = false;
                        this.isQx = false;
                        this.fetchData();
                        this.batch = 0;
                    });
            }
        });
    }
    // 点击批量删除
    showCheckBox(command: string) {
        if (this.delButton === "批量删除") {
            if (this.delIds.length === 0) {
                this.delButton = "取消";
            }
            if (this.notAllow == true) {
                this.delSome();
            } else {
                this.delButton = "取消";
                this.showCheck = true;
                this.notAllow = true;
            }
        } else {
            this.delButton = "批量删除";
            this.showCheck = false;
            this.notAllow = false;
            this.batch = 0;
        }
    }
    // 删除行
    delSome() {
        let delIdArray: any = [];
        this.delIds.forEach((val: DelIds) => {
            if (val.check) {
                delIdArray.push(val.id);
            }
        });
        this.$msgbox({
            message: `您共选了 ${delIdArray.length} 张发票，是否确认删除？`,
            title: "温馨提示",
            confirmButtonText: "确定",
            showCancelButton: true,
        }).then((action: any) => {
            if (action == "confirm") {
                Vue.axios
                    .post(`invoice/del?id=${delIdArray.join(",")}`)
                    .then((res) => {
                        this.delButton = "批量删除";
                        this.showCheck = false;
                        this.notAllow = false;
                        this.fetchData();
                        this.batch = 0;
                    });
            }
        });
    }
    businessTypeList = Providers;
    status = {
        id: "11",
        text: ""
    }
    statusList = [
        {
            text: "全部",
            id: "11",
        },
        {
            text: "未认证",
            id: "0",
        },
        {
            text: "已认证",
            id: "1",
        },
    ]
    getStatus(id: string) {
        if (id === "1") return "已认证"
        else return "未认证"
    }
    departmentList: DataTable.DropItem[] = [
        { text: "全部", id: 11 },
        { text: "管理部门", id: 0 },
        { text: "销售部门", id: 1 },
        { text: "研发部门", id: 2 },
        { text: "其他部门", id: 3 },
    ];
    invoiceList: DataTable.DropItem[] = [
        { text: "全部", id: 11 },
        { text: "普票", id: 0 },
        { text: "专票", id: 1 },
        // { text: "电子票", id: 2 },
    ];
    // 下拉
    businessType: DataTable.DropItem = { text: "", id: 123 };
    department: DataTable.DropItem = this.departmentList[0];
    invoice: DataTable.DropItem = this.invoiceList[0];
    //改变时间
    period: String[] = []; // 日期
    changeDate(date: string[]) {
        this.period = date;
        let closeP = this.$store.state.accountBook.closePeriod;
        // 判断是否结账
        if (closeP !== null) {
            if (closeP.toString() >= this.period[1]) {
                this.closePeriod = false;
            } else {
                this.closePeriod = true;
            }
        }
        this.fetchData();
    }
    //销项发票/进项发票切换
    purchase: boolean = true;
    changeIncoiceType(index: number) {
        if (index == 0) {
            this.purchase = true;
        } else {
            this.purchase = false;
        }
        this.startDate = "";
        this.endDate = "";
        this.minPriceTaxAmount = "";
        this.maxPriceTaxAmount = "";
        this.businessType = { text: "", id: 123 };
        this.department = this.departmentList[0];
        this.invoice = this.invoiceList[0];
        this.fetchData();
    }
    handlePeriod(val: string) {
        return `${val.substring(0, 4)}-${val.substring(4, 6)}-${val.substring(
            6,
            8
        )}`;
    }
    handleBusinessType(val: number) {
        if (ProviderArr[val] === "高速公路发票") return "通行费电子发票";
        else return ProviderArr[val];
    }
    handleDepartment(val: number) {
        return DepartArray[val];
    }
    // 获取表格数据
    invoiceData: Invoice.Invoice[] = [];
    totalMoneyAmounts: string = "";
    totalTaxAmounts: string = "";
    totalPriceTaxMoneyAmounts: string = "";
    onceFetchData() {
        this.pageSize = 20;
        this.currentPage = 1;
        this.fetchData();
    }
    export() {
        const url = `${Vue.axios.defaults.baseURL}export/invoice?accountBookId=${this.$store.state.accountBook.id}&token=${this.$store.state.account.token}&version=${version}&accounterId=${this.$store.state.account.id}&startPeriod=${this.period[0]}&endPeriod=${this.period[1]}&status=${this.status.id === "11" ? "" : this.status.id}&searchKey=${this.searchKey.trim()}&isProviderOrCustomer=${this.purchase ? 0 : 1}&businessType=${this.businessType.text === "" ? "" : this.businessType.id}&invoiceType=${this.invoice.id === 11 ? "" : this.invoice.id}&department=${this.department.id === 11 ? "" : this.department.id}&minPriceTaxAmount=${this.minPriceTaxAmount}&maxPriceTaxAmount=${this.maxPriceTaxAmount}&endDate=${(this.endDate != "" && this.endDate != null) ? this.$utils.simpleDateFormat(new Date(this.endDate), "d") : ""}&startDate=${(this.startDate != "" && this.startDate != null) ? this.$utils.simpleDateFormat(new Date(this.startDate), "d") : ""}`;
        this.$store.dispatch("toggleDownload", true);
        this.$utils.sendToElectron("download", url);
    }
    fetchData() {
        this.delButton = "批量删除";
        this.perButton = "批量修改期间";
        this.rzButton = "批量认证";
        this.downButton = "批量认证";
        this.batch = 0;
        this.clickPer = false;
        this.showCheck = false;
        this.isRz = false;
        this.isQx = false;
        this.isDown = false
        this.notAllow = false;
        this.delIds = [];
        Vue.axios
            .post(
                `invoice/findlist?page=${this.currentPage - 1}&size=${this.pageSize
                }`,
                {
                    status: this.status.id === "11" ? "" : this.status.id,
                    searchKey: this.searchKey.trim(),
                    accountBookId: this.$store.state.accountBook.id,
                    startPeriod: this.period[0],
                    endPeriod: this.period[1],
                    isProviderOrCustomer: this.purchase ? 0 : 1,
                    businessType:
                        this.businessType.text === ""
                            ? null
                            : this.businessType.id,
                    invoiceType:
                        this.invoice.id === 11 ? null : this.invoice.id,
                    department:
                        this.department.id === 11 ? null : this.department.id,
                    minPriceTaxAmount: this.minPriceTaxAmount,
                    maxPriceTaxAmount: this.maxPriceTaxAmount,
                    endDate: (this.endDate != "" && this.endDate != null) ? this.$utils.simpleDateFormat(new Date(this.endDate), "d") : "",
                    startDate: (this.startDate != "" && this.startDate != null) ? this.$utils.simpleDateFormat(new Date(this.startDate), "d") : ""

                }
            )
            .then((res) => {
                this.invoiceData = res.data.invoiceDtos.content;
                this.totalElements = res.data.invoiceDtos.totalElements;
                this.totalMoneyAmounts = res.data.totalMoneyAmounts;
                this.totalTaxAmounts = res.data.totalTaxAmounts;
                this.totalPriceTaxMoneyAmounts =
                    res.data.totalPriceTaxMoneyAmounts;
                let del = this.delIds;
                this.invoiceData.forEach((v: any) => {
                    this.delIds.push({
                        id: v.id,
                        customer: v.customer,
                        invoiceNo: v.invoiceNo,
                        url: v.url,
                        check: false,
                    });
                });
            });
    }
    // 判断发票类型显示
    isInvoiceType(type: string) {
        if (type === "0") return "普票";
        else if (type === "1") return "专票";
        else return "电子票";
    }

    // 导入zip
    importZipVisbile = false;
    scanVisible = false;
    importCommand(cmd: string) {
        if (cmd === "模板导入") {
            this.importData(false);
        } else {
            this.scanVisible = true;
        }
    }
}
